/* eslint-disable no-unused-vars */
export enum PaymentsActionType {
  GET_PAYMENTS = 'get_payments',
  GET_PAYMENTS_SUCCESS = 'get_payments_success',
  GET_PAYMENTS_FAILURE = 'get_payments_failure',
}
